import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 30px 45px 20px 45px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SideBarManipulator = styled.div`
  background: black;
  padding: 12px 0 12px;
  display: flex;
  justify-content: end;
  cursor: pointer;
`;
